import LoadingPage from './LoginPage'

export default LoadingPage